export default __webpack_public_path__ + "static/media/honnamana_kere_lake.5672cfc0.jpg";